import React from 'react'

import Button, { type ButtonProps } from '@components/Button'

const CallToAction = ({
  href,
  label,
  target,
  icon,
  iconPosition,
  className,
  variant,
}: ButtonProps) => {
  return (
    <Button
      href={href}
      target={target}
      icon={icon}
      iconPosition={iconPosition}
      className={className}
      variant={variant}
    >
      {label}
    </Button>
  )
}

export default CallToAction
